
        import 'MainPane.b1cbd32.css-module'
        export default {"MainPane":"MainPane_MainPane_b1cbd32"}
    